"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRefreshError = void 0;
const isRefreshError = (url) => {
    if (!url)
        return false;
    return url === '/auth/refresh';
};
exports.isRefreshError = isRefreshError;
